//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text1: {
      type: String,
      default: null
    },
    text2: {
      type: String,
      default: null
    },
    text3: {
      type: String,
      default: null
    }
  }
}
